import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body16Medium } from "@/components/typography/Body16Medium";
import { Table } from "flowbite-react";
import { useEffect, useState } from "react";
import { userService } from "../../../services/user-service";
import { AdminHomeItemDto } from "../../../types/dto/admin-home-item-dto";
import { CustomCell } from "../CustomCell";

interface Props {}

export const AdminHomeItemTable: React.FC<Props> = ({}) => {
  const headCellStyle = "font-medium text-gray-900 bg-gray-100";

  const [data, setData] = useState<AdminHomeItemDto>({
    item: {
      numIsForSale: 0,
      numOutOfStock: 0,
      numIsNotForSale: 0,
    },
    package: {
      numIsForSale: 0,
      numOutOfStock: 0,
      numIsNotForSale: 0,
    },
  });

  const getData = async () => {
    const response = await userService.getAdminHomeItem();
    setData(response.data);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="overflow-x-auto flex flex-col gap-[16px]">
      <div className="rounded-lg border overflow-hidden">
        <Table>
          <Table.Body>
            <Table.Row className="border-b border-gray-200 h-[38px]">
              <Table.Cell className={`${headCellStyle} w-[148px] p-0 h-[38px]`}>
                <CustomCell className="flex items-center mx-[15px] my-[8px]">
                  <Body14Regular className="text-semantic-text-secondary">
                    구분
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[320px] p-0 h-[38px] border-l`}
              >
                <CustomCell className="flex items-center mx-[15px] my-[8px]">
                  <Body14Regular className="text-semantic-text-secondary">
                    일반
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[320px] p-0 h-[38px] border-l`}
              >
                <CustomCell className="flex items-center mx-[15px] my-[8px]">
                  <Body14Regular className="text-semantic-text-secondary">
                    패키지
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[148px] p-0 h-[50px]`}>
                <CustomCell className="my-[14px]">
                  <Body14Regular className="text-semantic-text-secondary">
                    판매중
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[320px] bg-primary-white border-l">
                <CustomCell className="flex gap-[4px] my-[14px]">
                  <Body16Medium className="text-semantic-text-body">
                    {data.item.numIsForSale}
                  </Body16Medium>
                  <Body14Regular className="text-semantic-text-secondary">
                    개
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[320px] bg-primary-white border-l">
                <CustomCell className="flex gap-[4px] my-[14px]">
                  <Body16Medium className="text-semantic-text-body">
                    {data.package.numIsForSale}
                  </Body16Medium>
                  <Body14Regular className="text-semantic-text-secondary">
                    개
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[148px] p-0 h-[50px]`}>
                <CustomCell className="my-[14px]">
                  <Body14Regular className="text-semantic-text-secondary">
                    품절
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[320px] bg-primary-white border-l">
                <CustomCell className="flex gap-[4px] my-[14px]">
                  <Body16Medium className="text-semantic-text-body">
                    {data.item.numOutOfStock}
                  </Body16Medium>
                  <Body14Regular className="text-semantic-text-secondary">
                    개
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[320px] bg-primary-white border-l">
                <CustomCell className="flex gap-[4px] my-[14px]">
                  <Body16Medium className="text-semantic-text-body">
                    {data.package.numOutOfStock}
                  </Body16Medium>
                  <Body14Regular className="text-semantic-text-secondary">
                    개
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[148px] p-0 h-[50px]`}>
                <CustomCell className="my-[14px]">
                  <Body14Regular className="text-semantic-text-secondary">
                    판매 중지
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[320px] bg-primary-white border-l">
                <CustomCell className="flex gap-[4px] my-[14px]">
                  <Body16Medium className="text-semantic-text-body">
                    {data.item.numIsNotForSale}
                  </Body16Medium>
                  <Body14Regular className="text-semantic-text-secondary">
                    개
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[320px] bg-primary-white border-l">
                <CustomCell className="flex gap-[4px] my-[14px]">
                  <Body16Medium className="text-semantic-text-body">
                    {data.package.numIsNotForSale}
                  </Body16Medium>
                  <Body14Regular className="text-semantic-text-secondary">
                    개
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};
